import React, { useState } from "react";
import { Container, Typography, Grid, Tabs, Tab, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MenteeComponent from "../components/MenteeComponent";
import { blackmintTheme, deviceDesktopBreakpoint } from "../styles/theme";
import clsx from "clsx";
import MentorTaskView from "./views/MentorTaskView";
import MentorSessionView from "./views/MentorSessionView";
import {
  MentorshipSession,
  MentorshipTask,
  Student,
} from "../server/serverTypes";
import { useDispatch } from "react-redux";
import { actions as taskActions } from "../task/redux/model";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "20px",
    minHeight: "calc(100vh - 204px)",
    [theme.breakpoints.up(deviceDesktopBreakpoint)]: {
      padding: "0px 120px",
      // height: "100vh",
    },
  },
  h3: { ...blackmintTheme.typographyBlackmint.h3 },
  h5: {
    ...blackmintTheme.typographyBlackmint.h5,
  },
  tabRoot: {
    width: "50%",
    fontWeight: 400,
    color: "#757575",
  },
  indicator: {
    border: "1px solid #00664F",
  },
  selected: {
    fontFamily: "Inter",
    fontWeight: 800,
    color: "#00664F !important",
  },
}));

interface TabPanelProps {
  readonly children?: React.ReactNode;
  readonly index: number;
  readonly value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0} style={{ padding: "10px 0px" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

interface IMentorMainPage {
  tasks: MentorshipTask[];
  sessions: MentorshipSession[];
  student: Student;
}

const MentorMainPage = ({ tasks, sessions, student }: IMentorMainPage) => {
  const dispatch = useDispatch();

  const classes = useStyles();

  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: any) => {
    setValue(newValue);
  };

  const handleDelete = (id: number) => {
    dispatch(taskActions.deleteMentorshipTask({ id: id }));
  };

  const handleUpdate = (id: number) => {
    dispatch(taskActions.completeTask({ id: id }));
  };

  return (
    <Container className={classes.container}>
      <MenteeComponent
        withArrow={false}
        name={student.name}
        email={student.email}
        // student={student}
      />
      <Grid container style={{ margin: "12px 0px" }}>
        <Grid item xs={12}>
          <Typography className={classes.h3}>Mentor Dashboard</Typography>
        </Grid>
        <Grid item xs={12}>
          <div style={{ position: "static" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              centered
              classes={{ indicator: classes.indicator }}
            >
              <Tab
                label="Tasks"
                classes={{
                  root: clsx(classes.h5, classes.tabRoot),
                  selected: classes.selected,
                }}
              />
              <Tab
                label="Sessions"
                classes={{
                  root: clsx(classes.h5, classes.tabRoot),
                  selected: classes.selected,
                }}
              />
            </Tabs>
          </div>
          <TabPanel value={value} index={0}>
            <MentorTaskView
              tasks={tasks}
              addUrl={"/add-task"}
              handleDelete={handleDelete}
              handleUpdate={handleUpdate}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <MentorSessionView sessions={sessions} addUrl={"/add-session"} />
          </TabPanel>
        </Grid>
      </Grid>
    </Container>
  );
};

export default MentorMainPage;
